
<div class="container">
  <div class="row">
    <div class="col">
      <div class="btn-group float-right alert-create-controls">
        <button class="btn btn-primary btn-sm oi oi-plus" type="button" (click)="create()"></button>
      </div>
      <h2>Manage Alerts</h2>
    </div>
  </div>
  <div class="row card-item" *ngFor="let alert of alerts">
    <div class="col">
      <table class="table-sm" style="width: 100%;">
        <tr>
          <th class="text-right align-text-top" style="width: 120px;">Header:</th>
          <td>{{ alert.header }}</td>
          <td class="align-text-top alert-edit-controls" [attr.rowspan]="alert.controlsHeight || 3">
            <div>
              <button class="btn btn-sm btn-outline-primary oi oi-pencil" *ngIf="alert.id" type="button" (click)="edit(alert)"></button>
              <button class="btn btn-sm btn-outline-danger oi oi-trash" *ngIf="alert.id" type="button" (click)="remove(alert)"></button>
            </div>
          </td>
        </tr>
        <tr>
          <th class="text-right align-text-top">Text:</th>
          <td>{{ alert.text }}</td>
        </tr>
        <tr *ngIf="alert.bulletPointsList &amp;&amp; alert.bulletPointsList.length">
          <th class="text-right align-text-top">Bullet Points:</th>
          <td>
            <ul>
              <li *ngFor="let p of alert.bulletPointsList">{{ p }}</li>
            </ul>
          </td>
        </tr>
        <tr *ngIf="alert.footer">
          <th class="text-right align-text-top">Footer:</th>
          <td>{{ alert.footer }}</td>
        </tr>
        <tr>
          <th class="text-right align-text-top">Priority:</th>
          <td>{{ alert.priority }}</td>
        </tr>
        <tr *ngIf="alert.id">
          <th class="text-right align-text-top">ID:</th>
          <td>{{ alert.id }}</td>
        </tr>
      </table>
    </div>
  </div>
</div>